import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import { CircularProgress } from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import Messages from "../../../constants/Messages";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import uRLs from "../../../utils/baseUtils";
import AddImage from "./AddImage";
import { usePermission } from "../../../context/PermissionContext";
import { useContextApi } from "../../../context/ContextApi";
import { createPortal } from "react-dom";
import CustomUnit from "./CustomUnit";
import { useAuth } from "../../../context/AuthProvider";
import { handleChange } from "../../../utils/ProductHandleChange";
import { AddIcon, CheckIcon, EditIcon, ErrorCircleIcon, PlusIcon, XIcon } from "../../../constants/Icons";

const EditProduct = ({
  editData,
  onClose,
  onEdit,
  isBtnLoading,
  noteSuggests,
  isActive,
  brandSuggest,
  setBrandSuggest,
  fromProductView = true,
}) => {
  const { settings } = useAuth();
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [isSelectedRadio, setSelectedRadio] = useState("SALEPRICE");
  const [error, setErrors] = useState({});
  const hasFetched = useRef(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const { viewOption, setGlobelPopupOpen } = usePermission();
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [noteSuggest, setNoteSuggest] = useState(noteSuggests);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [filteredNoteSuggestions, setFilteredNoteSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const suggestionNoteRef = useRef([]);
  const [unitSuggest, setUnitSuggest] = useState({});
  const primaryRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [brandData, setBrandData] = useState({
    title: "",
    _id: "",
  });
  const itemRefs = useRef([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isBrandFocused, setIsBrandFocused] = useState(false);
  const [filteredBrand, setFilteredBrand] = useState([]);
  const [brandIndex, setBrandIndex] = useState(-1);
  const [AddUnitopen, setAddUnitopen] = useState(false);
  const [unitData, setUnitData] = useState();
  const { useEscapeKey } = useContextApi();
  const modalBodyRef = useRef(null);
  const containerRef = useRef(null);
  const productShortNameRef = useRef(null);
  const [productData, setProductData] = useState({
    code: "",
    hsnsac: "",
    title: "",
    note: "",
    mrp: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    landingcost: 0,
    brandName: "",
    shortName:"",
  });
  const productCodeRef = useRef(null);
  const productCodeGenerate = useRef(null);
  const productHsnsacRef = useRef(null);
  const brandRef = useRef(null);
  const productTitleRef = useRef(null);
  const productNoteRef = useRef(null);
  const productMrpRef = useRef(null);
  const productSalepriceRef = useRef(null);
  const productTaxpercentageRef = useRef(null);
  const productBasepriceRef = useRef(null);
  const editProductBtnRef = useRef(null);
  const productLandingCostRef = useRef(null);
  const searchTagRef = useRef(null);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const popupMrpInputRef = useRef(null);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});
  const [imageFile, setImageFile] = useState(null);
  const [isImageModalOpen, seImageModalOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(
    editData?.primaryImage
      ? uRLs.IMAGE_URL + editData?.primaryImage
      : "/assets/images/avatars/default.jpg",
  );

  const allUnits = [
    ...(settings?.defaultUnits || []).map((u) => ({
      unitCode: u.unitCode,
      unitName: u.unitName,
    })),
    ...(settings?.storeUnits || []).map((u) => ({
      unitCode: u.unitCode,
      unitName: u.unitName,
    })),
  ];

  const defaultConversion = allUnits?.find(
    (u) => u?.unitCode === unitData?.primaryUnitCode,
  );

  const handleOpenImageModel = () => {
    if (isImageModalOpen) return;
    seImageModalOpen(true);
    setIsMainModalOpen(false);
    setGlobelPopupOpen(true);
  };

  const handleMainModalReopen = () => {
    setIsMainModalOpen(true);
    setGlobelPopupOpen(false);
  };

  const handleImageClose = () => {
    seImageModalOpen(false);
    handleMainModalReopen();
  };
  const handleAddImage = (image) => {
    if (image) {
      setImageFile(image);
      setImagePreview(URL.createObjectURL(image));
      handleImageClose();
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!productData.code) {
      errors.code = Messages.ERROR.CODE_EMPTY;
    } else if (productData.code && !/^[^\s]*$/.test(productData.code)) {
      errors.name = Messages.ERROR.INVALID_INPUT;
    } else if (!productData.title) {
      errors.title = Messages.ERROR.TITLE_EMPTY;
    } else if (productData.hsnsac && !/^\d{4,8}$/.test(productData.hsnsac)) {
      errors.hsnsac = Messages.ERROR.INVALID_PRODUCT_HSN_SAC;
    } else if (
      productData.mrp === undefined ||
      productData.mrp === null ||
      productData.mrp === ""
    ) {
      errors.mrp = Messages.ERROR.MRP_EMPTY;
    } else if (productData.mrp && !/^\d*\.?\d{0,2}$/.test(productData.mrp)) {
      errors.mrp = Messages.ERROR.INVALID_INPUT;
    } else if (
      productData.saleprice === undefined ||
      productData.saleprice === null ||
      productData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
    } else if (
      productData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(productData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
    } else if (
      productData.taxpercentage === undefined ||
      productData.taxpercentage === null ||
      productData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
    } else if (
      productData.taxpercentage &&
      !/^[0-9]*$/.test(productData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
    } else if (
      productData.discount === undefined ||
      productData.discount === null ||
      productData.discount === ""
    ) {
      errors.discount = Messages.ERROR.DISCOUNT_EMPTY;
    } else if (
      productData.discount &&
      !/^\d*\.?\d{0,2}$/.test(productData.discount)
    ) {
      errors.discount = Messages.ERROR.INVALID_INPUT;
    } else if (
      productData.baseprice === undefined ||
      productData.baseprice === null ||
      productData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
    } else if (
      productData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(productData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
    } else if (
      productData.taxamount === undefined ||
      productData.taxamount === null ||
      productData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      productData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(productData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "code":
          productCodeRef.current?.focus();
          break;
        case "title":
          productTitleRef.current?.focus();
          break;
        case "hsnsac":
          productHsnsacRef.current?.focus();
          break;
        case "mrp":
          productMrpRef.current?.focus();
          break;
        case "saleprice":
          productSalepriceRef.current?.focus();
          break;
        case "taxpercentage":
          productTaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          productBasepriceRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const validateField = (name, value) => {
    switch (name) {
      case "title":
        return value.trim() === "" ? Messages.ERROR.TITLE_EMPTY : "";
      case "mrp":
        return value === "" ? Messages.ERROR.MRP_EMPTY : "";
      case "saleprice":
        return value === "" ? Messages.ERROR.SALEPRICE_EMPTY : "";
      // Add other validations as needed
      default:
        return "";
    }
  };

  const handleCalculate = (updateData) => {
    var { mrp, saleprice, baseprice, taxpercentage } = updateData;
    let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
    let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
    let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
    let numericTaxpercentage = parseInt(taxpercentage);
    let quanity = parseInt(1);
    let calculationResult;
    let lock = isSelectedRadio;
    try {
      calculationResult = priceCalculator.getAllPriceList(
        numericMrp,
        numericSaleprice,
        numericBaseprice,
        numericTaxpercentage,
        quanity,
        lock,
      );

      if (lock === "SALEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            baseprice: CurrencyConverter.toCurrency(
              calculationResult.basePrice,
              "INR",
            ),
          }));
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            calculationResult.basePrice,
            "INR",
          ),
        }));
      } else if (lock === "BASEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            saleprice: CurrencyConverter.toCurrency(
              calculationResult.salePrice,
              "INR",
            ),
          }));
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            calculationResult.salePrice,
            "INR",
          ),
        }));
      }
    } catch (error) {
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  const changeParams = {
    productData,
    clearErrorsOnChange: true,
    noteSuggest,
    brandSuggest,
    setProductData,
    setErrors,
    setFilteredNoteSuggestions,
    setShowNotePopup,
    setHighlightedIndex,
    setFilteredBrand,
    setBrandIndex,
    setIsBrandFocused,
    handleCalculate,
    validateField,
  };

  const addTag = (value) => {
    const clean = value.trim().toLowerCase(); // 👈 convert to small letters

    if (!clean) return;

    if (!tags.includes(clean)) {
      setTags((prev) => [...prev, clean]);
    }

    setTagInput("");
  };

  const handleTagKeyDown = (e) => {
    const value = tagInput;

    //  ENTER → add tag
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (value) {
        addTag(value);
      } else {
        handleEdit(e);
      }
      return;
    }

    //  BACKSPACE → remove last tag if input empty
    if (e.key === "Backspace" && !value) {
      setTags((prev) => prev.slice(0, -1));
      return;
    }

    //  INVALID KEY → create tag
    const isValidChar = /^[a-zA-Z0-9 .]$/.test(e.key);

    if (!isValidChar && e.key.length === 1) {
      e.preventDefault();
      addTag(value);
    }
  };

  const removeTag = (index) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const tagString = tags.join(" ");
    const updatedData = {
      ...productData,
      brandData,
      searchTag: tagString,
      isLock: isSelectedRadio,
      unitConfig: unitData,
      ...(productData.minimumSalePrice && {
        minimumSalePrice: CurrencyConverter.toCurrency(
          productData.minimumSalePrice || 0,
          "INR",
        ),
      }),
    };
    onEdit(updatedData, imageFile, true);
  };

  const handleUnit = (payload) => {
    if (!payload) return;

    setUnitData(payload);

    setUnitSuggest((prev) => {
      let updatedStore = [...(prev?.storeUnits || [])];

      // combine default + store units for checking
      const allUnits = [
        ...(prev?.defaultUnits || []),
        ...(prev?.storeUnits || []),
      ];

      // check primary unit
      const primaryExists = allUnits.some(
        (u) => u.unitCode === payload?.primaryUnitCode,
      );

      if (!primaryExists) {
        updatedStore.push({
          unitName: payload?.primaryUnitName,
          unitCode: payload?.primaryUnitCode,
        });
      }

      // check secondary unit
      if (payload?.secondaryUnitCode) {
        const secondaryExists = allUnits.some(
          (u) => u.unitCode === payload?.secondaryUnitCode,
        );

        if (!secondaryExists) {
          updatedStore.push({
            unitName: payload?.secondaryUnitName,
            unitCode: payload?.secondaryUnitCode,
          });
        }
      }

      return {
        ...prev,
        storeUnits: updatedStore,
      };
    });
  };

  const handleClose = () => {
    resetForm();
    setIsMainModalOpen(false);
    seImageModalOpen(false);
    onClose();
  };

  useEscapeKey(handleClose);
  const resetForm = () => {
    setProductData({
      code: "",
      hsnsac: "",
      title: "",
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      landingcost: 0,
      brandName: "",
      shortName:"",
    });
    setTags([]);
    setBrandData({
      title: "",
      _id: "",
    });
    setErrors("");
  };

  const handleGenerateBarcode = async () => {
    setButtonLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/product`);
      const newBarcode = response.data.results.barcode;
      setProductData((prevData) => ({
        ...prevData,
        code: newBarcode,
      }));
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setButtonLoading(false);
      productCodeRef.current?.focus();
    }
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    const flatSuggestions = [
      ...(filteredNoteSuggestions["General"]
        ? filteredNoteSuggestions["General"]
        : []),
      ...Object.entries(filteredNoteSuggestions)
        .filter(([category]) => category !== "General")
        .flatMap(([_, items]) => items),
    ];

    if (showNotePopup && flatSuggestions.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev < flatSuggestions.length - 1 ? prev + 1 : 0,
        );
        return;
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev > 0 ? prev - 1 : flatSuggestions.length - 1,
        );
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();
        if (highlightedIndex >= 0) {
          const selectedItem = flatSuggestions[highlightedIndex];
          setProductData((prev) => ({
            ...prev,
            note: selectedItem,
          }));
          setShowNotePopup(false);
          setHighlightedIndex(-1);

          setTimeout(() => {
            nextRef?.current?.focus();
          }, 100);
          return;
        }
      }
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const code = String(productData["code"] || "").trim();
      if (fieldName === "code") {
        if (!code) {
          handleGenerateBarcode();
          setTimeout(() => {
            nextRef?.current?.focus();
          }, 100);
        } else {
          productHsnsacRef?.current?.focus();
        }
        return;
      }

      if (fieldName === "generate") {
        setTimeout(() => {
          nextRef?.current?.focus();
        }, 100);
        return;
      }

      if (fieldName === "title") {
        if (!validateForm()) return;
      }

      if (nextRef === productMrpRef) {
        // const rect = nextRef.current.getBoundingClientRect();
        // setPopupMrpStyle({
        //   position: "absolute",
        //   top: `${rect.top + window.scrollY}px`,
        //   left: `${rect.left + window.scrollX}px`,
        //   width: `${rect.width}px`,
        //   zIndex: 10000,
        // });
        setPopupMrpStyle(getMrpPopupStyle(nextRef));
        setPopupMrpValue(productData.mrp);
        setShowMrpPopup(true);
      }

      // const trimmedData = String(productData[fieldName] || "").trim();
      // const requiredFields = ["title"];

      // if (requiredFields.includes(fieldName) && !trimmedData) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     [fieldName]:
      //       Messages.ERROR[`${fieldName.toUpperCase()}_EMPTY`] || "Required",
      //   }));
      //   return;
      // }

      if (isLast) {
        handleEdit(e);
      } else {
        nextRef?.current?.focus();
      }
    }
  };

  const handleSelectBrand = (item) => {
    setBrandData((prev) => ({
      ...prev,
      title: item?.title,
      _id: item?._id,
    }));

    setShowSuggestions(false);
  };
  const handleBrandKeyDown = (e) => {
    const value = searchTerm?.trim();
    const hasAddOption =
      searchTerm?.trim() !== "" && filteredBrand?.length === 0;

    const totalItems = hasAddOption ? 1 : filteredBrand?.length;

    // if (totalItems === 0) return;

    if (filteredBrand?.length === 0) {
      if (e.key === "Enter" && value !== "") {
        e.preventDefault();
        handleBrandAdd(value);
        setShowSuggestions((prev) => !prev);
        productNoteRef.current?.focus();
      }
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setBrandIndex((prev) => (prev < totalItems - 1 ? prev + 1 : 0));
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setBrandIndex((prev) => (prev > 0 ? prev - 1 : totalItems - 1));
    }

    if (e.key === "Enter") {
      e.preventDefault();
      if (value === "" && brandIndex === -1) {
        setShowSuggestions((prev) => !prev);
        productNoteRef.current?.focus();
        return;
      }
      //  ADD NEW
      if (hasAddOption && brandIndex === 0) {
        handleBrandAdd(searchTerm);
        productNoteRef.current?.focus();
        return;
      }

      //  SELECT EXISTING
      if (brandIndex >= 0 && filteredBrand[brandIndex]) {
        handleSelectBrand(filteredBrand[brandIndex]);
        productNoteRef.current?.focus();
      }
    }
  };
  const handleBrandAdd = async (brandName) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.post(`module/product/brand`, {
        brandName: brandName,
      });
      const result = response?.data?.results;

      const newBrand = {
        _id: result?._id,
        title: result?.brandName,
      };

      setBrandSuggest((prev) => {
        // avoid duplicate
        const exists = prev.some((item) => item?.title === newBrand?.title);
        if (exists) return prev;

        return [newBrand, ...prev]; //  correct way
      });

      setBrandData((prev) => ({
        ...prev,
        title: newBrand.title,
        _id: newBrand._id,
      }));

      setShowSuggestions(false);
      setSearchTerm("");
      return newBrand?.title;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleRadioChange = (inputName) => {
    setSelectedRadio(inputName);
  };

  const stopEventPropagation = (e) => e.stopPropagation();

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionNoteRef.current[highlightedIndex]) {
      suggestionNoteRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  const flatSuggestions = [
    ...(filteredNoteSuggestions["General"]
      ? filteredNoteSuggestions["General"]
      : []),
    ...Object.entries(filteredNoteSuggestions)
      .filter(([category]) => category !== "General")
      .flatMap(([_, items]) => items),
  ];

  const handleUnitClose = () => {
    setAddUnitopen(false);
    setGlobelPopupOpen(false);
    productHsnsacRef.current.focus();
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowNotePopup(false);
        setHighlightedIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (setUnitData) {
      if (!editData.isLock) {
        editData.isLock = "SALEPRICE";
      }
      setProductData(editData);
      setSelectedRadio(editData.isLock);
      setUnitData(editData?.unitConfig);
    }
    setBrandData((prev) => ({
      ...prev,
      title: editData?.brandId,
    }));

    const tagsarr = editData?.searchTag
      ? editData.searchTag.trim().split(/\s+/).filter(Boolean)
      : [];
    setTags(tagsarr);
  }, [editData]);
  useEffect(() => {
    if (!editData || !isActive) return;

    const timer = setTimeout(() => {
      productTitleRef.current?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [editData, isActive]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    setNoteSuggest(noteSuggests);
  }, [noteSuggest]);
  // if (!isMainModalOpen && !isImageModalOpen ) return null;

  useEffect(() => {
    setUnitSuggest({
      defaultUnits: settings?.defaultUnits || [],
      storeUnits: settings?.storeUnits || [],
    });
  }, []);
  const getMrpPopupStyle = (inputRef) => {
    const scrollParent = inputRef.current.closest(".modal-body");
    if (!scrollParent) return {};
    return {
      position: "absolute",
      top: "208px",
      left: "16px",
      width: "130px",
      zIndex: 10000,
    };
  };

  useEffect(() => {
    if (showSuggestions) {
      setFilteredSuggestions(brandSuggest);
    }
  }, [brandSuggest, showSuggestions]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (primaryRef.current && !primaryRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(() => {
    if (brandIndex >= 0) {
      itemRefs.current[brandIndex]?.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [brandIndex]);
  return (
    <div>
      {isMainModalOpen && (
        <>
          <div className="modal-overlay" style={{ zIndex: 999 }}>
            {/* <div className="modal-box"> */}
            <div className="modal-backdrop show"></div>
            <div
              className="modal show"
              id="CustomerModal"
              tabIndex="-1"
              aria-modal="true"
              role="dialog"
              // onClick={handleClose}
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
                onClick={stopEventPropagation}
              >
                <div className="modal-content" style={{ position: "relative" }}>
                  <div className="modal-header">
                    <h6 className="modal-title">Edit Product</h6>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleClose}
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body bg-light" ref={modalBodyRef}>
                    <div className="card mb-0">
                      <div className="card-body">
                        <div className="row g-3">
                          {uRLs.ADD_PRODUCT_IMAGE === "true" &&
                            (viewOption("productSettings", "isPrimaryImage") ||
                              viewOption(
                                "generalSettings",
                                "isProductImage",
                              )) && (
                              <>
                                <div className="col-md-12 col-12">
                                  <div className="">
                                    <div className="row g-2">
                                      <div
                                        className=""
                                        onClick={handleOpenImageModel}
                                      >
                                        <div className="">
                                          <div className="profile-img-container">
                                            <img
                                              id="logoimg"
                                              className="avatar"
                                              src={imagePreview}
                                              alt="profile-img"
                                              style={{
                                                width: "100%",
                                                maxWidth: "100%",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                border: "2px solid #ddd",
                                              }}
                                            />

                                            {/* Hover Icon */}
                                            <div
                                              className="overlay-icon"
                                              onClick={() =>
                                                document
                                                  .getElementById(
                                                    `logo_image_popup_${editData?.id || "default"}`,
                                                  )
                                                  .click()
                                              }
                                            >
                                              <PlusIcon/>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Hidden Input */}
                                        <input
                                          id={`logo_image_popup_${editData?.id || "default"}`}
                                          type="file"
                                          accept="image/*"
                                          style={{ display: "none" }}
                                          onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                              handleAddImage(file);
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-md-5 col-6 d-flex align-items-center justify-content-start">
                           {isBtnLoading ? (
                             <button
                               className="btn btn-primary pb-0 text-right"
                               disabled
                             >
                               <CircularProgress
                                 size={22}
                                 className="text-white"
                               />
                             </button>
                           ) : (
                             <button
                               type="button"
                               className="btn btn-sm btn-primary text-right"
                               onClick={handleEdit}
                               ref={editProductBtnRef}
                             >
                               <i className="bx bx-check"></i> Update Image
                             </button>
                           )}
                         </div> */}
                              </>
                            )}
                          <div
                            className={
                              uRLs.UNIT === "true" ? "col-8" : "col-12"
                            }
                          >
                            <label htmlFor="title" className="form-label">
                              Title <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              autoComplete="off"
                              ref={productTitleRef}
                              value={productData.title}
                              onChange={(e) => handleChange(e, changeParams)}
                              onKeyDown={(e) =>
                                handleEnterKey(e, "title", productHsnsacRef)
                              }
                            />
                            {error.title && (
                              <div className="invalid-feedback">
                                {error.title}
                              </div>
                            )}
                          </div>
                          {uRLs.UNIT === "true" && (
                            <div className="col-4">
                              <label htmlFor="unit" className="form-label">
                                Unit{" "}
                                <span
                                  className="ms-1"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="right"
                                  title="Unit cannot be edited once stock has been added for this product."
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <ErrorCircleIcon/>{" "}
                                </span>
                              </label>
                              <div className="d-flex align-items-center">
                                <button
                                  type="button "
                                  className={`btn ${productData.unitLocked ? "btn-unit-diabled" : "btn-unit"} fs-10 w-100 d-flex align-items-center justify-content-between`}
                                  onClick={() => {
                                    if (
                                      productData?.unitConfig ||
                                      "unitLocked" in productData
                                    ) {
                                      if (!productData.unitLocked) {
                                        setAddUnitopen(true);
                                        setGlobelPopupOpen(true);
                                      }
                                    }
                                  }}
                                >
                                  {defaultConversion?.unitName ? (
                                    <>
                                      <span>{defaultConversion?.unitName}</span>
                                      {!productData.unitLocked && (
                                        <EditIcon iClass={"me-1"}/>
                                      )}{" "}
                                    </>
                                  ) : (
                                    <>
                                      <span>Unit</span>{" "}
                                      {(productData?.unitConfig ||
                                        "unitLocked" in productData) &&
                                        !productData.unitLocked && (
                                          <AddIcon iClass={"me-1"}/>
                                        )}{" "}
                                    </>
                                  )}
                                </button>
                              </div>
                              {unitData && (
                                <span>
                                  1 {unitData?.primaryUnitCode} ={" "}
                                  {unitData?.secondaryUnitCode
                                    ? `${unitData?.conversion} ${unitData?.secondaryUnitCode}`
                                    : "1 Unit"}
                                </span>
                              )}
                            </div>
                          )}
                          <div className="col-6">
                            <label htmlFor="phone" className="form-label">
                              Barcode / SKU / Code{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-group mb-0">
                              <input
                                type="text"
                                className="form-control"
                                name="code"
                                disabled
                                autoComplete="off"
                                ref={productCodeRef}
                                value={productData.code}
                                onInput={(e) => handleChange(e, changeParams)}
                                onKeyDown={(e) =>
                                  handleEnterKey(e, "code", productCodeGenerate)
                                }
                              />
                              {/* {isButtonLoading ? (
                              <button
                                className="btn btn-primary pb-0 text-right"
                                disabled
                              >
                                <CircularProgress
                                  size={22}
                                  className="text-white"
                                />
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary text-right"
                                onClick={handleGenerateBarcode}
                                ref={productCodeGenerate}
                                onKeyDown={(e) =>
                                  handleEnterKey(
                                    e,
                                    "generate",
                                    productHsnsacRef,
                                  )
                                }
                              >
                                <i className="bx bx-barcode"></i> Generate
                              </button>
                            )} */}
                            </div>
                            {error.code && (
                              <div className="invalid-feedback">
                                {error.code}
                              </div>
                            )}
                          </div>
                          <div className="col-lg-6">
                            <label htmlFor="hsnsac" className="form-label">
                              {" "}
                              HSN/SAC{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="hsnsac"
                              autoComplete="off"
                              ref={productHsnsacRef}
                              value={productData.hsnsac}
                              onChange={(e) => handleChange(e, changeParams)}
                              onKeyDown={(e) =>
                                handleEnterKey(e, "hsnsac", productMrpRef)
                              }
                            />
                            {error.hsnsac && (
                              <div className="invalid-feedback">
                                {error.hsnsac}
                              </div>
                            )}
                          </div>
                          <div className="col-12 border-top ">
                            <div className="fw-600 mt-2">
                              Amount{" "}
                              {unitData?.primaryUnitCode ? (
                                <span className="">
                                  (Per {unitData?.primaryUnitCode})
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <label htmlFor="mrp" className="form-label">
                              {" "}
                              MRP{" "}
                            </label>
                            {showMrpPopup && (
                              <input
                                type="text"
                                disabled={
                                  productData?.isStock && fromProductView
                                }
                                ref={popupMrpInputRef}
                                value={popupMrpValue}
                                onChange={(e) => {
                                  const val = e.target.value;

                                  // Regex: only digits, optional one dot, up to 2 decimals
                                  const regex = /^\d+(\.\d{0,2})?$/;

                                  if (val === "" || regex.test(val)) {
                                    setPopupMrpValue(val);
                                    setProductData((prev) => ({
                                      ...prev,
                                      mrp: val,
                                    }));
                                    handleCalculate({
                                      ...productData,
                                      mrp: val,
                                    });
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    setShowMrpPopup(false);
                                    setTimeout(() => {
                                      productSalepriceRef?.current?.focus();
                                    }, 0);
                                  }
                                }}
                                onBlur={() => setShowMrpPopup(false)}
                                autoFocus
                                onFocus={(e) => e.target.select()}
                                // style={popupMrpStyle}
                                className="form-control"
                              />
                            )}
                            {!showMrpPopup && (
                              <input
                                type="text"
                                className="form-control"
                                name="mrp"
                                autoComplete="off"
                                ref={productMrpRef}
                                disabled={
                                  productData?.isStock && fromProductView
                                }
                                value={productData.mrp}
                                onFocus={(e) => e.target.select()}
                                onChange={(e) => handleChange(e, changeParams)}
                                onKeyDown={(e) =>
                                  handleEnterKey(e, "mrp", productSalepriceRef)
                                }
                                onClick={() => {
                                  // const rect =
                                  //   productMrpRef.current.getBoundingClientRect();
                                  setPopupMrpStyle(
                                    getMrpPopupStyle(productMrpRef),
                                  );
                                  setPopupMrpValue(productData.mrp);
                                  setShowMrpPopup(true);
                                }}
                              />
                            )}
                            {error.mrp && (
                              <div className="invalid-feedback">
                                {error.mrp}
                              </div>
                            )}
                          </div>
                          <div className="col-lg-4">
                            <label htmlFor="saleprice" className="form-label">
                              Sale Price <span className="text-danger">*</span>
                            </label>

                            <div className="input-container position-relative">
                              <input
                                type="text"
                                name="saleprice"
                                disabled={
                                  productData?.isStock && fromProductView
                                }
                                autoComplete="off"
                                ref={productSalepriceRef}
                                value={productData.saleprice}
                                className="form-control"
                                onFocus={(e) => e.target.select()}
                                onClick={() => handleRadioChange("SALEPRICE")}
                                style={{ paddingLeft: "30px" }}
                                onChange={(e) => handleChange(e, changeParams)}
                                onKeyDown={(e) =>
                                  handleEnterKey(
                                    e,
                                    "saleprice",
                                    productTaxpercentageRef,
                                  )
                                }
                              />
                              <input
                                type="radio"
                                name="selectInput"
                                disabled={
                                  productData?.isStock && fromProductView
                                }
                                checked={isSelectedRadio === "SALEPRICE"}
                                className="position-absolute"
                                style={{
                                  top: "50%",
                                  left: "10px",
                                  transform: "translateY(-50%)",
                                  zIndex: 2,
                                }}
                              />
                            </div>
                            {error.saleprice && (
                              <div className="invalid-feedback">
                                {error.saleprice}
                              </div>
                            )}
                          </div>
                          <div className="col-lg-4">
                            <label htmlFor="FisrtName" className="form-label">
                              Tax(%) <span className="text-danger">*</span>
                            </label>
                            <select
                              name="taxpercentage"
                              className="form-select"
                              disabled={productData?.isStock && fromProductView}
                              ref={productTaxpercentageRef}
                              value={productData.taxpercentage}
                              onChange={(e) => handleChange(e, changeParams)}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "taxpercentage",
                                  productBasepriceRef,
                                )
                              }
                            >
                              <option value="0">0</option>
                              <option value="5">5</option>
                              <option value="12">12</option>
                              <option value="18">18</option>
                              <option value="24">24</option>
                            </select>
                          </div>
                          <div className="col-lg-4">
                            <label htmlFor="discount" className="form-label">
                              Discount
                            </label>
                            <input
                              readOnly=""
                              type="text"
                              name="discount"
                              autoComplete="off"
                              value={productData.discount}
                              className="form-control"
                              disabled
                            />
                          </div>
                          <div className="col-lg-4">
                            <label htmlFor="baseprice" className="form-label">
                              Base Price
                            </label>
                            <div className="input-container position-relative">
                              <input
                                type="text"
                                name="baseprice"
                                disabled={
                                  productData?.isStock && fromProductView
                                }
                                autoComplete="off"
                                ref={productBasepriceRef}
                                onClick={() => handleRadioChange("BASEPRICE")}
                                onChange={(e) => handleChange(e, changeParams)}
                                value={productData.baseprice}
                                onFocus={(e) => e.target.select()}
                                className="form-control"
                                style={{ paddingLeft: "30px" }}
                                onKeyDown={(e) =>
                                  handleEnterKey(
                                    e,
                                    "baseprice",
                                    productLandingCostRef,
                                  )
                                }
                              />
                              <input
                                type="radio"
                                name="selectInput"
                                disabled={
                                  productData?.isStock && fromProductView
                                }
                                className="position-absolute"
                                checked={isSelectedRadio === "BASEPRICE"}
                                style={{
                                  top: "50%",
                                  left: "10px",
                                  transform: "translateY(-50%)",
                                  zIndex: 2,
                                }}
                              />
                            </div>
                            {error.baseprice && (
                              <div className="invalid-feedback">
                                {error.baseprice}
                              </div>
                            )}
                          </div>
                          <div className="col-lg-4">
                            <label htmlFor="taxamount" className="form-label">
                              Tax Amount
                            </label>
                            <input
                              readOnly=""
                              type="text"
                              name="taxamount"
                              autoComplete="off"
                              className="form-control"
                              value={productData.taxamount}
                              disabled
                            />
                          </div>
                          <div className="col-12 border-top"></div>
                          <div className="col-lg-5">
                            <div className="d-flex align-items-center">
                              <label
                                htmlFor="landingcost"
                                className="form-label"
                              >
                                Landing Cost{" "}
                                <small>
                                  (Per{" "}
                                  {unitData?.primaryUnitCode
                                    ? unitData?.primaryUnitCode
                                    : "Unit"}
                                  ) (Optional)
                                </small>
                              </label>
                              <span className="tooltip-container">
                                <span className="tooltip-icon">?</span>
                                <span className="tooltip-text">
                                  Total cost to bring the product to your
                                  inventory, including purchase price and taxes.
                                </span>
                              </span>
                            </div>
                            <div className="input-container position-relative">
                              <input
                                type="text"
                                name="landingcost"
                                autoComplete="off"
                                ref={productLandingCostRef}
                                value={productData.landingcost}
                                className="form-control"
                                onFocus={(e) => e.target.select()}
                                onChange={(e) => handleChange(e, changeParams)}
                                // onKeyDown={(e) =>
                                //   {if(viewOption("productSettings", "isProductTag")){
                                //   handleEnterKey(e, "landingcost", searchTagRef)}else{
                                //     handleEnterKey(e, "searchTag", brandRef);setShowSuggestions((prev) => !prev);setFilteredBrand(brandSuggest);
                                //   }
                                //   }
                                // }
                                onKeyDown={(e) => {
                                  handleEnterKey(e, "landingcost", brandRef);
                                  if (e.key === "Enter") {
                                    setShowSuggestions((prev) => !prev);
                                    setFilteredBrand(brandSuggest);
                                  }
                                }}
                              />
                            </div>
                          </div>
                          {/* {viewOption("productSettings", "isProductTag") && (
                      <div
                        className={"col-4 d-flex align-items-end"}
                      >
                        <div>
                        <label htmlFor="searchTag" className="form-label">
                          Product Tag 
                        </label>
                        
                        <input
                          type="text"
                          className="form-control"
                          name="searchTag"
                          autoComplete="off"
                          ref={searchTagRef}
                          value={productData?.searchTag}
                          onChange={handleChange}
                          onFocus={(e) => e.target.select()}
                          onKeyDown={(e) => {handleEnterKey(e, "searchTag", brandRef);setShowSuggestions((prev) => !prev);setFilteredBrand(brandSuggest);}}
                        />  
                        </div>
                        </div>)} */}
                          {/* {viewOption("productSettings", "isProductTag") && (
                          <div className="col-12">
                          <label className="form-label">Product Tag</label>
                        
                          <div className="tag-input-container">
                          {tags?.map((tag, index) => (
                              <span className="tag-chip" key={index}>
                                {tag}
                                <span className="tag-close" onClick={() => removeTag(index)}>
                                <CancelRoundedIcon sx={{fontSize:15}}/>
                                </span>
                              </span>
                            ))}
                        
                            <input
                              type="text"
                              className="tag-input"
                              value={tagInput}
                              ref={searchTagRef}
                              onChange={(e) => setTagInput(e.target.value)}
                              onKeyDown={handleTagKeyDown}
                              onBlur={() => {
                                const value = tagInput.trim();
                                if (value) {
                                  addTag(value);
                                }
                              }}
                              placeholder="Type and press Enter"
                            />
                          </div>
                        </div>
                        )} */}
                          <div
                            className="col-lg-7"
                            style={{ marginTop: "35px" }}
                          >
                            <label className="form-label">Brand</label>

                            <div className="position-relative" ref={primaryRef}>
                              {/* Trigger */}
                              {showSuggestions && (
                                <div
                                  className="dropdown-menu show w-100 p-2 shadow-sm"
                                  style={{
                                    bottom: "100%",
                                    top: "auto",
                                    marginBottom: "5px",
                                    borderTopLeftRadius: "0px",
                                    borderTopRightRadius: "0px",
                                  }}
                                >
                                  {/* Search */}
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search or add new..."
                                    ref={brandRef}
                                    value={searchTerm}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setSearchTerm(value);

                                      if (value.trim() === "") {
                                        setFilteredBrand(brandSuggest);
                                      } else {
                                        const filtered = brandSuggest.filter(
                                          (item) =>
                                            item.title
                                              .toLowerCase()
                                              .includes(value.toLowerCase()),
                                        );
                                        setFilteredBrand(filtered);
                                      }

                                      setBrandIndex(-1);
                                    }}
                                    onFocus={(e) => e.target.select()}
                                    onKeyDown={handleBrandKeyDown}
                                    autoFocus
                                  />

                                  <ul
                                    className="suggestions-list-top "
                                    style={{
                                      maxHeight: "150px",
                                      borderBottomLeftRadius: "0px",
                                      borderBottomRightRadius: "0px",
                                      borderBottom: "0",
                                      boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    {/*Add new */}
                                    {filteredBrand?.length === 0 &&
                                      searchTerm?.trim() !== "" && (
                                        <li
                                          className={`suggestion-item text-primary ${
                                            brandIndex === 0
                                              ? "highlighted rounded"
                                              : ""
                                          }`}
                                          onMouseDown={() =>
                                            handleBrandAdd(searchTerm)
                                          }
                                        >
                                          <span className="p-2 rounded-3 badge bg-label-primary d-flex align-items-center">
                                          <AddIcon iClass={"me-1"}/>{" "}
                                            "{searchTerm}"
                                          </span>
                                        </li>
                                      )}

                                    {/* List */}
                                    {filteredBrand?.map((item, index) => (
                                      <li
                                        key={item?._id}
                                        className={`suggestion-item mx-2 ${
                                          index === brandIndex
                                            ? "highlighted rounded"
                                            : ""
                                        }`}
                                        ref={(el) =>
                                          (itemRefs.current[index] = el)
                                        }
                                        onMouseDown={() =>
                                          handleSelectBrand(item)
                                        }
                                      >
                                        {item?.title}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                              <div
                                className="form-control d-flex justify-content-between align-items-center"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setShowSuggestions((prev) => !prev);
                                  setSearchTerm("");
                                  setFilteredBrand(brandSuggest); //  show all
                                  setBrandIndex(-1);
                                }}
                              >
                                <span
                                  className={
                                    brandData?.title ? "" : "text-muted"
                                  }
                                >
                                  {brandData?.title || "Select brand"}
                                </span>
                                <span className="d-flex align-items-center">
                                  {brandData?.title && (
                                    // <i className="bx bx-x me-2" ></i>
                                    <CancelRoundedIcon
                                      sx={{ fontSize: 15 }}
                                      onClick={() => setBrandData("")}
                                    />
                                  )}
                                  <i
                                    className={`bx bx-chevron-${showSuggestions ? "up" : "down"} ms-2`}
                                  />
                                </span>
                              </div>

                              {/* Dropdown */}
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <label htmlFor="title" className="form-label">
                              Note
                            </label>
                            <div
                              className="position-relative"
                              ref={containerRef}
                            >
                              <input
                                type="text"
                                className="form-control"
                                name="note"
                                autoComplete="off"
                                ref={productNoteRef}
                                value={productData.note}
                                onChange={(e) => handleChange(e, changeParams)}
                                onKeyDown={(e) =>
                                  handleEnterKey(e, "note", productShortNameRef)
                                }
                                onFocus={() => {
                                  setFilteredNoteSuggestions(noteSuggest);
                                  setShowNotePopup(true);
                                  setHighlightedIndex(-1);
                                }}
                                onBlur={() => {
                                  setTimeout(() => {
                                    setShowNotePopup(false);
                                  }, 150);
                                }}
                                style={{ paddingRight: productData.note ? "30px" : undefined }}
                              />
                      {productData.note && (
                          <button
                            type="button"
                            onMouseDown={(e) => {
                              // prevent input blur before we clear
                              e.preventDefault();
                            }}
                            onClick={() => {
                              setProductData((prev) => ({
                                ...prev,
                                note: "",
                              }));
                              productNoteRef.current?.focus();
                            }}
                            className="noteclose"
                            aria-label="Clear note"
                          >
                            <CancelRoundedIcon
                              sx={{ fontSize: 15 }}
                              />
                          </button>
                        )}
                              {showNotePopup &&
                                Object.values(filteredNoteSuggestions).flat()
                                  .length > 0 && (
                                  <ul className="suggestions-list-top">
                                    {[
                                      // Put "General" first if it exists
                                      ...(filteredNoteSuggestions["General"]
                                        ? [
                                            [
                                              "General",
                                              filteredNoteSuggestions[
                                                "General"
                                              ],
                                            ],
                                          ]
                                        : []),

                                      // Then add all other categories
                                      ...Object.entries(
                                        filteredNoteSuggestions,
                                      ).filter(
                                        ([category]) => category !== "General",
                                      ),
                                    ].map(([category, items], catIndex) => (
                                      <li key={catIndex}>
                                        <div className="suggestion-item highlighted-title">
                                          {category}
                                        </div>
                                        <ul className="suggestions-list-inside">
                                          {items.map((item, idx) => {
                                            const flatIndex =
                                              flatSuggestions.indexOf(item);
                                            return (
                                              <li
                                                key={`${catIndex}-${idx}`}
                                                ref={(el) =>
                                                  (suggestionNoteRef.current[
                                                    flatIndex
                                                  ] = el)
                                                }
                                                className={`suggestion-item ${
                                                  highlightedIndex === flatIndex
                                                    ? "highlighted"
                                                    : ""
                                                }`}
                                                onMouseDown={() => {
                                                  setProductData((prev) => ({
                                                    ...prev,
                                                    note: item,
                                                  }));
                                                  setShowNotePopup(false);
                                                  setHighlightedIndex(-1);
                                                }}
                                              >
                                                {item}
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </div>
                          {viewOption("productSettings", "isShortName") && (
                    <div className="col-12">
                      <label htmlFor="shortName" className="form-label">
                        Short Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="shortName"
                        autoComplete="off"
                        ref={productShortNameRef}
                        value={productData?.shortName}
                        onChange={(e) => handleChange(e, changeParams)}
                        onFocus={(e) => e.target.select()}
                        onKeyDown={(e) => {
                          handleEnterKey(e, "shortName", searchTagRef)
                          }}
                      />
                    </div>)}
                          {viewOption("productSettings", "isProductTag") && (
                            <div className="col-12">
                              <label className="form-label">Search Tag</label>

                              <div className="tag-input-container">
                                {tags?.map((tag, index) => (
                                  <span className="tag-chip" key={index}>
                                    {tag}
                                    <span
                                      className="tag-close"
                                      onClick={() => removeTag(index)}
                                    >
                                      <CancelRoundedIcon
                                        sx={{ fontSize: 15 }}
                                      />
                                    </span>
                                  </span>
                                ))}

                                <input
                                  type="text"
                                  className="tag-input"
                                  value={tagInput}
                                  ref={searchTagRef}
                                  onChange={(e) => setTagInput(e.target.value)}
                                  onKeyDown={handleTagKeyDown}
                                  onBlur={() => {
                                    const value = tagInput.trim();
                                    if (value) {
                                      addTag(value);
                                    }
                                  }}
                                  placeholder="Type and press Enter"
                                />
                              </div>
                            </div>
                          )}
                          {/* <div className="col-lg-4">
                        <div>
                          <label htmlFor="brandName" className="form-label">
                            Brand
                          </label>
                          <div className="position-relative" >
                          <input
                            type="text"
                            className="form-control"
                            name="brandName"
                            autoComplete="off"
                            ref={brandRef}
                            value={productData?.brandName}
                            onChange={handleChange}
                            onFocus={() => {setIsBrandFocused(true);setFilteredBrand(brandSuggest);}}
                            onBlur={() => {
                              // delay to allow click
                              setTimeout(() => setIsBrandFocused(false), 150);
                            }}
                            // onKeyDown={(e) => handleEnterKey(e, "brandName", productNoteRef)}/
                            onKeyDown={handleBrandKeyDown}
                          /> 
                          {isBrandFocused && filteredBrand?.length > 0 && (
                              <ul className="suggestions-list-top">
                                {filteredBrand?.map((item, index) => (
                                  <li
                                    key={index}
                                    className={`suggestion-item ${
                                      brandIndex === index ? "highlighted" : ""
                                    }`}
                                    onMouseDown={() => handleSelectBrand(item)}
                                  >
                                    <span>{item?.title}</span>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          </div>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer d-block">
                    <button
                      type="button"
                      className="btn btn-outline-secondary text-left"
                      onClick={handleClose}
                    >
                      <XIcon/> Close
                    </button>
                    {isBtnLoading ? (
                      <button
                        className="btn btn-primary pb-0 text-right"
                        disabled
                      >
                        <CircularProgress size={22} className="text-white" />
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary text-right"
                        onClick={handleEdit}
                        ref={editProductBtnRef}
                      >
                        <CheckIcon/> Update Product
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* </div> */}
          </div>
        </>
      )}
      {isImageModalOpen && (
        <AddImage
          onClose={handleImageClose}
          data={imageFile}
          ImageView={imagePreview}
          Ontrigger={true}
          onAdd={handleAddImage}
        />
      )}
      {AddUnitopen && (
        <CustomUnit
          onclose={() => {
            handleUnitClose();
          }}
          unitSuggest={unitSuggest}
          onAdd={handleUnit}
          selectedData={unitData}
        />
      )}
    </div>
  );
};

export default EditProduct;
